<template>
  <div class="contact-page">
    <header class="page-header">
      <div class="container">
        <h1>联系我们</h1>
        <p>如有任何疑问或建议，请随时联系我们</p>
      </div>
    </header>

    <div class="container">
      <div class="contact-content">
        <div class="contact-info">
          <h2>联系方式</h2>
          
          <div class="info-group">
            <div class="info-item">
              <div class="info-icon">📍</div>
              <div class="info-text">
                <span class="info-label">新院区地址</span>
                <span class="info-value">云南省昆明市呈贡区春融街203号</span>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">📍</div>
              <div class="info-text">
                <span class="info-label">老院区地址</span>
                <span class="info-value">云南省昆明市五华区华山西路5号</span>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">📞</div>
              <div class="info-text">
                <span class="info-label">咨询电话</span>
                <span class="info-value">0871-65156666</span>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">🚑</div>
              <div class="info-text">
                <span class="info-label">急诊电话</span>
                <span class="info-value">0871-65156120</span>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">✉️</div>
              <div class="info-text">
                <span class="info-label">电子邮箱</span>
                <span class="info-value">contact@ynfybjy.com</span>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">🕐</div>
              <div class="info-text">
                <span class="info-label">工作时间</span>
                <span class="info-value">周一至周日 8:00-18:00（急诊24小时）</span>
              </div>
            </div>
          </div>

          <div class="map-section">
            <h3>院区地图</h3>
            <div class="map-placeholder">
              <img src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=hospital%20location%20map%20pin%20marker%20city%20street%20map&image_size=landscape_16_9" alt="地图" />
            </div>
          </div>
        </div>

        <div class="contact-form">
          <h2>在线留言</h2>
          <form @submit.prevent="submitForm">
            <div class="form-group">
              <label>您的姓名</label>
              <input type="text" v-model="form.name" placeholder="请输入姓名" />
            </div>
            <div class="form-group">
              <label>联系电话</label>
              <input type="tel" v-model="form.phone" placeholder="请输入电话号码" />
            </div>
            <div class="form-group">
              <label>电子邮箱</label>
              <input type="email" v-model="form.email" placeholder="请输入邮箱地址" />
            </div>
            <div class="form-group">
              <label>咨询类型</label>
              <select v-model="form.type">
                <option value="">请选择咨询类型</option>
                <option value="medical">医疗咨询</option>
                <option value="appointment">预约咨询</option>
                <option value="complaint">意见建议</option>
                <option value="other">其他</option>
              </select>
            </div>
            <div class="form-group">
              <label>留言内容</label>
              <textarea v-model="form.content" placeholder="请输入您的留言内容..." rows="5"></textarea>
            </div>
            <button type="submit" class="submit-btn">提交留言</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        type: '',
        content: ''
      }
    }
  },
  methods: {
    submitForm() {
      if (!this.form.name || !this.form.content) {
        alert('请填写必填项')
        return
      }
      this.$Message.success('留言提交成功，我们会尽快回复您')
      this.form = {
        name: '',
        phone: '',
        email: '',
        type: '',
        content: ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.contact-page {
  min-height: 100vh;
  background: #f5f5f5;
}

.page-header {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  padding: 40px 0;
  text-align: center;

  h1 {
    font-size: 32px;
    margin-bottom: 10px;
  }

  p {
    font-size: 16px;
    opacity: 0.9;
  }
}

.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 30px 20px;
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}

.contact-info {
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);

  h2 {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 25px;
    padding-bottom: 15px;
    border-bottom: 2px solid #4facfe;
  }
}

.info-group {
  margin-bottom: 30px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 15px 0;
  border-bottom: 1px dashed #eee;

  &:last-child {
    border-bottom: none;
  }

  .info-icon {
    font-size: 24px;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f8ff;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .info-text {
    display: flex;
    flex-direction: column;

    .info-label {
      font-size: 12px;
      color: #999;
      margin-bottom: 3px;
    }

    .info-value {
      font-size: 14px;
      color: #333;
    }
  }
}

.map-section {
  h3 {
    font-size: 16px;
    color: #333;
    margin-bottom: 15px;
  }

  .map-placeholder {
    border-radius: 10px;
    overflow: hidden;
    height: 250px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.contact-form {
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);

  h2 {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 25px;
    padding-bottom: 15px;
    border-bottom: 2px solid #4facfe;
  }

  .form-group {
    margin-bottom: 20px;

    label {
      display: block;
      font-size: 14px;
      color: #666;
      margin-bottom: 8px;
    }

    input, select, textarea {
      width: 100%;
      padding: 12px;
      border: 1px solid #ddd;
      border-radius: 8px;
      font-size: 14px;

      &:focus {
        outline: none;
        border-color: #4facfe;
      }
    }

    textarea {
      resize: vertical;
    }
  }

  .submit-btn {
    width: 100%;
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    color: white;
    border: none;
    padding: 15px;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }
  }
}

@media (max-width: 768px) {
  .contact-content {
    grid-template-columns: 1fr;
  }
}
</style>
